
import React, { useState, useEffect, useCallback, useRef } from "react";

import { useLocation, useNavigate, useParams } from "react-router-dom";

//components
import DataTable from "../../../../components/Tables/DataTable";
import AutoComplete from "../../../../components/AutoComplete";
//hooks
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import useAuth from "../../../../hooks/useAuth";
import useMutationAuth from "../../../../hooks/useMutationAuth";
import Tooltip from "../../../../components/Tooltip";
import ConfirmationModal from "../../../../components/Modal/ConfirmationModal";

//graphql
import {
  APPROVE_PENDING_TIMESHEET,
 CREATE_OPEN_TIMESHEET,
  DELETE_TIMESHEET,
  EDIT_TIMESHEET_TIME_ENTRIES,
  GET_TIMESHEET_DESCRIPTION,
  GET_TIMESHEETS_LIST,
  REMOVE_TIMEENTRIES,
  RENAME_TIMESHEET,
  REOPEN_APPROVED_TIMESHEET,
  SEND_TIMESHEET_APPROVAL_NOTIFICATION,
} from "../../../../graphql/timesheet";
import { DELETE_TIME_ENTRY_LIST } from "../../../../graphql/timeEntry";
import { GET_USER_TABLE_PREFERENCES } from "../../../../graphql/userTablePreferences";
import { GET_ALL_PROJECTS_DROPDOWN } from "../../../../graphql/project";
//editors
import { Parse } from "../../../../JSON.editor";

//mnemonic values
import Mnemonic from "../../../../Mnemonics.json";

import urls from "../../../../urls";

import { UTC2Time, formatDateTimeToString } from "../../../../UTC2Local";

//external components
import { CircularProgress, Grid, Box, Autocomplete, TextField} from "@mui/material";

import ContainerCard from "../../../../components/Cards/ContainerCard";
import PaperComponent from "../../../../components/Modal/PaperComponent";
import UTC2Local from "../../../../UTC2Local";
import componentDisplay from "../../../../componentDisplay";
import EditRecord from "../Timesheets-Form/components/EditRecord";
import { useSnackbar } from "notistack";

import { useTranslation } from "react-i18next";
import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";
import TimeEntryDrawer from "../Timesheets-Form/components/TimeEntryDrawer";
import CustomButton from "../../../../components/CustomButton";
import {
  NextIcon,
  PreviousIcon,
  RequestApprovalIcon,
  ExportIconButton,
  ReopenIcon,
  GetEntriesIcon,
  
  MoveIcon,
  ApproveIconButton
} from "../../../../components/Icon";
import AutoCompletePaper from "../../../../components/Paper/AutoCompletePaper";
import RoundedTextField from "../../../../components/TextFields/RoundedTextField";
import RoundedDatePicker from "../../../../components/DateField/RoundedDatePicker";
import { handleValidateDates } from "../../../../utils/functions";
import {
  DATE_FILTER_DATA,
  handleDateBackward,
  handleDateForward,
  handleTimeBetween,
} from "../../../../utils/period";
import colors from "../../../../assets/theme/light/colors";
import apiCall from "../../../../hooks/useRest";
import { useDispatch } from "react-redux";
import * as FileSaver from "file-saver";
import { LOGOUT_USER } from "../../../../graphql/user";
import { saveToken } from "../../../../app/reducers/tokenSlice";

import { v4 as uuidv4 } from "uuid";
import { removeNullProps } from "../../../../utils/removeNullProps";
import { decodeUnicodeString } from "../../../../utils/decodeUnicodeString";
import MoveTimeEntryModal from "../../TimeEntries/MoveTimeEntry";
import { GET_ALL_PROJECT_PERMISSIONS } from "../../../../graphql/projectPermission";
import StatusCell from "../../../../components/StatusCell";
import PlaylistRemoveOutlinedIcon from '@mui/icons-material/PlaylistRemoveOutlined';
//import ExcelFileIcon from "../../../../assets/images/excel-file.svg";

const backendURL = process.env.REACT_APP_REST_URL;

const NewTimesheet = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { tID, tName } = useParams();

  const { t } = useTranslation();


  const data_filter = DATE_FILTER_DATA(t);

  const { my_approved_timesheets, my_created_timesheets, my_approved_timesheet_form, my_pending_timesheet_form } = urls;
  
  const { storeUserGuid, storeUserTenant, userRoles,  logout } =
    useAuth();

  const { manageTimeEntry } = userRoles;

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [defaultFilters, setDefaultFilters] = useState({});
  const [columns, setColumns] = useState([]);
  const [linkCell, setLinkCell] = useState(false);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [clickCount, setClickCount] = useState(0);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [search, setSearch] = useState("");
  const [projectGuid, setProjectGuid] = useState([])
  const [rows, setRows] = useState([]);
  const [excelRows, setExcelRows] = useState([]);
  const [editPendingCount, setEditPendingCount] = useState(0)
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [numberRecords, setNumberRecords] = useState(0);
  const [totalDuration, setTotalDuration] = useState(0);
  const [clicked, setClicked] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
   const [timesheetApprover, setTimesheetApprover] = useState(null);
  const [timeEntry, setTimeEntry] = React.useState(null);
  const [taskID, setTaskID] = useState(null);
  const [timesheetGuid, setTimesheetGuid] = useState("");
  const [timesheetName, setTimesheetName] = useState("");
  const [openMoveTaskDialog, setOpenMoveTaskDialog] = useState(false);
  const [timesheetID, setTimesheetID] = useState("");
  const [taskName, setTaskName] = useState(null);
  const [projectID, setProjectID] = useState(null);
  const [projectName, setProjectName] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [projectInfo, setProjectInfo] = useState([])
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openApprovalDialog, setOpenApproverDialog] = useState(false)
  const [showWarning, setShowWarning] = useState(false);
  const [reopenSheet, setReopenSheet] = useState(false);
  const [timeEntriesClicked, setTimeEntriesClicked] = useState(false);
  const [deletedRecords, setDeletedRecords] = useState([]);
  const fetchedFromLocation = useRef(true);
  const locationDateFrom = useRef(null);
  const locationDateTo = useRef(null);
  const type = useRef("task");
  const { dark_logo_blue } = colors;
  const [isQueryEnabled, setIsQueryEnabled] = useState(false);

  const [re, setRe] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const { mfunction: logsOutUser } = useMutationAuth(LOGOUT_USER, "LogoutUser");
  const updateToken = (updatedToken) => {
    if (updatedToken) dispatch(saveToken(updatedToken));
  };
  const nowDate = new Date();

  const firstDayOfWeek = new Date(nowDate);
  firstDayOfWeek.setDate(
    nowDate.getDate() - nowDate.getDay() + (nowDate.getDay() === 0 ? -6 : 1)
  );

  const [dateFrom, setDateFrom] = useState(firstDayOfWeek);
 // const [triggerTimesheetQuery, setTriggerTimesheetQuery] = useState(false);

  const lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

  const [dateTo, setDateTo] = useState(lastDayOfWeek);

  const [fromTimesheet, setFromTimsheet] = useState(false)

  const [open, setOpen] = useState(false);

  const [timer, setTimer] = useState(null);

  const [projectValue, setProjectValue] = useState([]);

  const [dateFromSheet, setDateFromSheet] = useState("");
  const [dateToSheet, setDateToSheet] = useState("");
  const [projectNameSheet, setProjectNameSheet] = useState("");
  const [status, setStatus] = useState(null);
  const [description, setDescription] = useState("")
  const [toSave, setToSave] = useState(false);

  const [dateVal, setDateVal] = useState(
    data_filter.find((x) => x.mnemonic === "week")
  );

  function disableDates(date) {
    const oneDayBefore = new Date(dateFrom);
    oneDayBefore.setDate(oneDayBefore?.getDate() - 1);
    return date < oneDayBefore;
  }

   const [editPendingMode, setEditPendingMode] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setEditPendingMode(searchParams.get('edit') === 'true');
  }, [location.search])


  const handleClose = () => {
    setOpenDialog(false);
  };

  const [closeWarning, setCloseWarning] = useState(false)

  const handleWarningClose = () => {
    if (editPendingMode && editPendingCount === 1) {
      setCloseWarning(true)
      setEditPendingCount(0)

    }
    setShowWarning(false);
    setTimeEntriesClicked(false)
    setFromTimsheet(false)
  };

  const handleSave = () => {
    reopenSheet ? handleApprove() : handleReopenTimesheet();
    handleClose();
  };

  const { mfunction: editTimesheet } = useMutationAuth(
    EDIT_TIMESHEET_TIME_ENTRIES,
    "EditTimesheetTimeEntries"
  );

  const editTimeSheet = () => {
    editTimesheet(
      {
        variables: {
          id: tID,
        },
      },
      (response) => {
        enqueueSnackbar(t("timesheet.list.delete.success"), {
          variant: "success",
        });

        setRows([])
        fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
      }
    )
  }

  const handleWarningSave = () => {
    if (editPendingMode && editPendingCount === 1 && !closeWarning) {
      editTimeSheet();
    } else {
      handleDeleteTimesheet();
    }
    setShowWarning(false); // Close the warning modal
    setFromTimsheet(false)
  };

  const { mfunction: updateRecords } = useMutationAuth(
    RENAME_TIMESHEET,
    "UpdateTimesheet"
  );


  // const handleUpdate = () => {
  //   updateRecords(
  //     {
  //       variables: {
  //         model: {
  //           timesheetGuid: timesheetGuid || tID,
  //           description: description,
  //         },
  //       },
  //     },
  //     () => {
  //       enqueueSnackbar(t("invoices.list.undo.success"), {
  //         variant: "success",
  //       });
  //       setOpenEditDialog(false)
  //       setRe((v) => !v);
  //       setSelected([]);
  //       setPage(0);
  //       setTriggerTimesheetQuery(false)

  //     }
  //   );
  // };

  const [timesheetApproverChanged, setIsTimesheetApproverChanged] = useState(false)
  const [saveResourceGuid, setSaveResourceGuid] = useState(null)

  const handlechangeTimesheetApprover = (resourceGuid) => {
    sessionStorage.setItem(
      "unsavedChanges",
      JSON.stringify(true)
    )
    setTimesheetApprover(resourceGuid)
    setIsTimesheetApproverChanged(true)
    setSaveResourceGuid(resourceGuid)
    setToSave(true)
  }
  useEffect(()=>{
    if(toSave)
     handleSaveButton()
  },[toSave])
  const {
    data: timesheetData,
    loading: timesheetLoading,
    tokenChange: timesheetWait,
  } = useQueryAuth(GET_TIMESHEET_DESCRIPTION, "GetTimesheetDescription", {
    variables: {
      id: timesheetGuid || tID,
    },
    skip: !tID,
  });

  const timesheetDescription = timesheetData?.GetTimesheetDescription?.description


  const [isChanged, setIsChanged] = useState(false);

  const handleChange = (event) => {
    sessionStorage.setItem(
      "unsavedChanges",
      JSON.stringify(true)
    )
    setDescription(event.target.value);
    setIsChanged(event.target.value !== timesheetDescription);
  };

  useEffect(() => {

    if (timesheetDescription) {
      setDescription(timesheetDescription)
      setIsChanged(false)
    }
  }, [timesheetDescription]);




  const handleOpenApproveConfirmationModal = (flag) => {
    setReopenSheet(flag);
    setOpenDialog(true);
  };

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape") {
        setOpenDialog(false);
        setShowWarning(false)
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const { mfunction: approveTimesheet } = useMutationAuth(
    APPROVE_PENDING_TIMESHEET,
    "ApprovePendingTimesheet"
  );



  const {
    data: projectsData,
    loading: projectLoading,
    tokenChange: projectsWait,
  } = useQueryAuth(GET_ALL_PROJECTS_DROPDOWN, "GetAllProjects", {
    variables: {
      model: {
        enableFilters: false,
        tenantID: storeUserTenant,
        userID: storeUserGuid,
        fetchTime: true,
      },
    },
  });

  const projectsList =
    projectsData?.GetAllProjects?.projectsList?.projectViews || [];





  useEffect(() => {
    if (projectValue && projectsList) {
      const foundProject = projectsList.find(p => {
        return p.projectGuid === projectValue;
      });

      if (foundProject && foundProject.title) {
        setProjectValue(foundProject.title)
        // Here you can do something with the found project's title
      } else {
        <></>
      }
    }
  }, [projectValue, projectsList]); // Ensures effect runs when projectGuid or projectsList changes


  useEffect(() => {
    if (location?.state?.timeEntries?.length > 0) {
      var project = location.state.timeEntries[0].project;
      if (project && projectsList) {
        const selectedProject = projectsList.find(p => p.projectGuid === project);
        if (selectedProject) {
          setProjectValue(selectedProject);
          fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
        }
      }
    } else {
      fetchedFromLocation.current = false;
    }
  }, [location, projectsList, page, rowsPerPage, order, orderBy, search, defaultFilters]);


  useEffect(() => {
    if (projectValue && projectValue.length && projectInfo && projectInfo.length) {
      // Initialize start and end with extreme values to compare against
      let start = new Date();
      let end = new Date(0); // A very old date for initialization

      projectInfo.forEach(project => {
        // Check each project for the oldest start time
        if (project?.oldestTimeEntry?.startTime) {
          const projectStart = new Date(project.oldestTimeEntry.startTime);
          if (projectStart < start) {
            start = projectStart;
          }
        }

        // Check each project for the latest end time
        if (project?.latestTimeEntry?.endTime) {
          const projectEnd = new Date(project.latestTimeEntry.endTime);
          if (projectEnd > end) {
            end = projectEnd;
          }
        }
      });

      // Fallbacks if no valid dates were found in the projects
      if (start >= new Date() || isNaN(start)) {
        start = locationDateFrom.current ? new Date(locationDateFrom.current) : new Date();
      }
      if (end <= new Date(0) || isNaN(end)) {
        end = locationDateTo.current ? new Date(locationDateTo.current) : new Date();
      }

      setDateFrom(start);
      setDateTo(end);
      setDateVal(data_filter.find((x) => x.mnemonic === "custom"));
    }
  }, [projectValue, fetchedFromLocation.current, projectInfo]);

  const {
    data: tableColumns,
    loading: getColumnsLoading,
    refetch: refetchColumns,
    tokenChange: columnsWait,
  } = useQueryAuth(GET_USER_TABLE_PREFERENCES, "GetUserTablePreferences", {
    variables: {
      model: {
        table: Mnemonic.Tables.TimesheetList,
        userID: storeUserGuid,
      },
    },
    skip: projectsWait,
    isWait: true,
  });

  useEffect(() => {
    if (tableColumns) {
      let col = tableColumns.GetUserTablePreferences.columns;

      const actions = ({ compProps }) => {
        let props = compProps;
        return (
          <EditRecord
            {...props}
            handleClick={(v) => setClicked(v)}
            handleRowSelect={(t) => setTimeEntry(t)}
            handleEditMode={(v) => setEditMode(v)}
            disabled={manageTimeEntry !== "M"}
          />
        );
      };

      if (col) {
        col = decodeUnicodeString(col);

        //we parse the json string to a json object
        const parsed = JSON.parse(col, (key, value) =>
          Parse(key, value, UTC2Local, componentDisplay, UTC2Time, actions, null, formatDateTimeToString)
        );

        if (parsed.defaultSort) setOrderBy(parsed.defaultSort);

        if (parsed.defaultSortDirection) setOrder(parsed.defaultSortDirection);

        const colmns = parsed.columns;
        if (colmns) {
          colmns.forEach((col) => {
            col = removeNullProps(col)
            if (col.id === "date")
              return (col.renderCell = (row) => {
                return formatDateTimeToString(row?.startTime, false);
              });
          });
          setLinkCell(colmns.some((col) => col.link === true));
          
          setColumns(colmns);
        }
      }
    }
  }, [tableColumns, tID]);

  const filtersObject = [
   
  ];

  const { mfunction: reopenTimesheetRecord } = useMutationAuth(
    REOPEN_APPROVED_TIMESHEET,
    "ReopenApprovedTimeSheet"
  );

  const handleReopenTimesheet = () => {
    handleCloseMenu()
    if (status) {
      reopenTimesheetRecord({
        variables: {
          id: tID,
        },
      }, (response) => {
        enqueueSnackbar(t("timesheet.list.status.success"), {
          variant: "success",
        });
        setSelected([]);
        setPage(0);
        navigate(urls.edit_pending_timesheet.replace(
          "/:tName/:tID",
          `/${encodeURIComponent(timesheetName)}/${encodeURIComponent(timesheetID)}?edit=true`
        ));
        setStatus(false);
      });
    }
  };

  // const editTimeSheet = () => {
  //   editTimesheet(
  //     {
  //       variables: {
  //         id: tID,
  //       },
  //     },
  //     (response) => {
  //       enqueueSnackbar(t("timesheet.list.delete.success"), {
  //         variant: "success",
  //       });
  //       const dateTo = new Date(response?.EditTimesheetTimeEntries?.timeSheetView?.endDate);
  //       const dateFrom = new Date(response?.EditTimesheetTimeEntries?.timeSheetView?.startDate);

  //       setRows([])
  //       setDateFrom(dateFrom)
  //       setDateTo(dateTo)
  //       const path = urls.my_pending_timesheet_form.replace(
  //         "/:tName/:tID",
  //         `/${encodeURIComponent(row?.description)}/${encodeURIComponent(row?.timeSheetGuid)}`
  //       );

  //       navigate(path);
  //     }
  //   )
  // }



  const { mfunction: removeTimeEntry, loading: deleteLoading } =
    useMutationAuth(REMOVE_TIMEENTRIES, "RemoveTimeEntries");

  const handleDelete = () => {
    removeTimeEntry(
      {
        variables: {
          model: {
            timeEntriesIDs: selected,
          },
        },
      },
      (response) => {
        enqueueSnackbar(t("timesheet.list.delete.success"), {
          variant: "success",
        });
        setRe((v) => !v);
        setSelected([]);
        setPage(0);
        setProjectGuid(null)
      }
    );
  };

  const { mfunction: deleteTimesheet, loading: deleteTimesheetLoading } =
    useMutationAuth(DELETE_TIMESHEET, "DeleteTimeSheet");

  const handleDeleteTimesheet = () => {
    // Check if the timesheetGuid is null or undefined
    if (!timesheetGuid) {
      editTimeSheet()
      return; // Exit the function to prevent further execution
    }

    deleteTimesheet(
      {
        variables: {
          timesheetGuid: timesheetGuid || tID,
        },
      },
      (response) => {
        enqueueSnackbar(t("timesheet.list.delete.success"), {
          variant: "success",
        });
        setRe((v) => !v);
        setSelected([]);
        setPage(0);
      }
    );
  };

  useEffect(() => {
    if (tID || tName) {
      setTimesheetID(tID)
      setTimesheetName(tName)
    }
  }, [tID, tName])
  async function exportData() {
    handleCloseMenu()
    if (!excelTimeSheetLoading ) {
      const res = await apiCall(
        backendURL + `/ExportExcel/exportTimeSheet`,
        "POST",
        {
          "items": excelRows,
          "projectName": projectNameSheet,
          "dateFrom": dateFromSheet,
          "dateTo": dateToSheet
        },
        logsOutUser,
        logout,
        updateToken,
        enqueueSnackbar,
        t,
        null,
        "blob"
      );

      if (res) {
        let fileName = "ApprovedTimeSheet" + Date.now() + ".xlsx"; // Default file name

        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const blob = new Blob([res.data], { type: fileType });

        FileSaver.saveAs(blob, fileName);
        enqueueSnackbar(t("report.exportSuccessfully"), { variant: "success" });
      }
    }
  }

  const {
    mfunction: getTimeEntries,
    loading,
    refetch: refetchTimeEntries,
  } = useLazyQueryAuth(CREATE_OPEN_TIMESHEET, "CreateOpenTimesheet");


  const {
    mfunction: getAllTimesheets,
    loading: timeEntriesLoading,
    refetch: refetchTimesheet,
  } = useLazyQueryAuth(GET_TIMESHEETS_LIST, "GetTimeSheetTimeEntries");


  const {
    data: TimesheetsForExcel,
    loading: excelTimeSheetLoading,
    tokenChange: timesheetsWait,
  } = useQueryAuth(GET_TIMESHEETS_LIST, "GetTimeSheetTimeEntries", {
    variables: {
      model: {
        enableFilters: true,

        filters: defaultFilters,
        keyword: search,
        orderColumn: orderBy,
        orderDirection: order,
        timesheetGuid: tID,
        userID: storeUserGuid,
      },
    },

    skip: !isQueryEnabled || tID !== null ||projectsWait||timesheetGuid!==null||deleteTimesheetLoading,
    isWait: true,
    enabled: isQueryEnabled && tID != null
  });


  useEffect(() => {
    setExcelRows(TimesheetsForExcel?.GetTimeSheetTimeEntries?.timeSheetTimeEntries
      ?.timeEntries)
  
  }, [tID, TimesheetsForExcel])

  const [TimeEntries, setTimeEntries] = useState([])


  const fetchTableData = useCallback(
    (
      page = 0,
      pageSize = 0,
      order = "",
      orderBy = "",
      search = "",
      filters = null
    ) => {
      if ((timesheetGuid || tID) && !timeEntriesClicked) {
        getAllTimesheets(
          {
            variables: {
              model: {
                enableFilters: true,
                keys: {
                  page: page + 1,
                  pageSize: pageSize,
                },
                filters: filters,
                keyword: search,
                orderColumn: orderBy,
                orderDirection: order,
                timesheetGuid: timesheetGuid || tID,
                userID: storeUserGuid,
              },
            },
          },
          (response) => {
            setTimeEntries(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.timeEntries)
            const originalStrTo = UTC2Local(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.dateTo);
            const dateTo = new Date(originalStrTo.replace('at', ''));
            const dateFrom = new Date(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.dateFrom);
            // Function to format the date in "dd/Mon/yyyy" format
            function formatDate(date) {
              const day = date.getDate().toString().padStart(2, '0');
              const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
              const month = months[date.getMonth()];
              const year = date.getFullYear();

              return `${day}/${month}/${year}`;
            }

            // Format the dates
            const formattedDateTo = formatDate(dateTo);
            const formattedDateFrom = formatDate(dateFrom);

            locationDateTo.current = new Date(formattedDateTo);
            locationDateFrom.current = new Date(formattedDateFrom);
            setDateTo(locationDateTo.current);
            setDateFrom(locationDateFrom.current);
            setIsQueryEnabled(true)
            setRows(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.timeEntries);
            setNumberRecords(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.totalNumberOfRecords);
            setTotalDuration(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.totalDuration);
            setDateFromSheet(UTC2Local(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.dateFrom));
            setDateToSheet(UTC2Local(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.dateTo));
            setProjectNameSheet(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.projectName);
            setStatus(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.approved)
            setProjectValue(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.projectGuids)
            setTimesheetApprover(response?.GetTimeSheetTimeEntries?.timeSheetTimeEntries?.approverResource?.employeeGuid)
          }
        );
      } else if (timeEntriesClicked || (timeEntriesClicked && timesheetGuid)) {
        getTimeEntries(
          {
            skip: !timeEntriesClicked || tID,
            variables: {
              model: {
                tenantID: storeUserTenant,
                userID: storeUserGuid,
                getTimeEntriesRequest: {
                  keys: {
                    page: page + 1,
                    pageSize: pageSize,
                  },
                  dateFrom: dateFrom.toDateString(),
                  dateTo: dateTo.toDateString(),
                  projectGuids: projectValue,
                  filters: filters,
                  keyword: search,
                  orderColumn: orderBy,
                  orderDirection: order,
                  userID: storeUserGuid,
                },
              },
            },
          },
          (response) => {
            setTimesheetGuid(response?.CreateOpenTimesheet?.timeEntriesList?.timesheetGuid);
            if (!response?.CreateOpenTimesheet?.timeEntriesList?.timesheetGuid) {
              enqueueSnackbar(t("timesheet.noTimesheetFound.warning"), {
                variant: "warning",
              });
              setRows([])
              setTotalDuration(0)
              setNumberRecords(0)
            } else {
              if (editPendingMode) {
                const description = response?.CreateOpenTimesheet?.timeEntriesList?.timesheetDescription
                const projectTitle = encodeURIComponent(description);
                const timesheetGuid = response?.CreateOpenTimesheet?.timeEntriesList?.timesheetGuid;

                if (timesheetGuid) {
                  const newPath = urls.edit_pending_timesheet.replace("/:tName", `/${projectTitle}`).replace("/:tID", `/${encodeURIComponent(timesheetGuid)}`) + "?edit=true";
                  navigate(newPath, {
                    state: response?.CreateOpenTimesheet?.timeEntriesList,
                  });
                } else {
                  enqueueSnackbar(t("error.missingTimesheetGuid"), { variant: "error" });
                }
              }
              setStatus(false)
              setIsQueryEnabled(true);
              setTimeEntriesClicked(false);
              setRows(response?.CreateOpenTimesheet?.timeEntriesList?.timeEntries);
              setNumberRecords(response?.CreateOpenTimesheet?.timeEntriesList?.totalNumberOfRecords);
              setTotalDuration(response?.CreateOpenTimesheet?.timeEntriesList?.totalDuration);
              setDateFromSheet(dateFrom.toDateString());
              setDateToSheet(dateTo.toDateString());
              setDateTo(dateTo);
              setDateFrom(dateFrom)
              setTimeEntries(response?.CreateOpenTimesheet?.timeEntriesList?.timeEntries)
              setProjectNameSheet(projectInfo.title);
              setTimesheetApprover(response?.CreateOpenTimesheet?.timeEntriesList?.approverResource?.employeeGuid)
            }
          }
        );
      }
    },
    [timesheetGuid, projectValue, dateFrom, dateTo, timeEntriesClicked, editPendingMode, projectInfo]
  );




  useEffect(() => {
    if (!columnsWait)
      fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);

  }, [columnsWait, re]);

  useEffect(() => {
    if (!columnsWait && timesheetGuid) {
      fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
    }
  }, [columnsWait]);

  const handleApprove = () => {
    approveTimesheet(
      {
        variables: {
          model: {
            userGuid: storeUserGuid,
            timesheetGuid: timesheetGuid || tID,
          },
        },
      },
      (response) => {
        enqueueSnackbar(t("timesheet.approval.success"), {
          variant: "success",
        });
        setStatus(true)
        navigate(urls.my_approved_timesheet_form.replace(
          "/:tName/:tID",
          `/${encodeURIComponent(timesheetName)}/${encodeURIComponent(timesheetID)}?edit=true`
        ));
      }
    )
  };
  const handleRefresh = () => {
    fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
  };
 

  const customButtons = [
    
    {
      label: "timesheet.create.Search",
      handleClick: () => {
        getTimeEntriesButton()
      },
      condition:true,
      icon: true,
      disabled:status ,
      iconButton: <GetEntriesIcon color={dark_logo_blue}/>,
    },
    {
      label:"timesheet.btn.clear",
      icon:true,
      condition: (!selected || selected?.length === 0) &&
      manageTimeEntry === "M" &&
      !timeEntriesClicked ,
      disabled: !rows || exportLoading || rows?.length < 1||status ,
      iconButton:<PlaylistRemoveOutlinedIcon style={{
        color: "red",
        width: "24px",
        height: "24px",
        strokeWidth:"1"
      }}/>,
      handleClick: () =>  setOpenDeleteDialog(true) 
    },
    {
      label: "timesheet.btn.reopen.label",
      handleClick: () => {
        handleReopenTimesheet()
      },
      condition:status &&
      tID &&
      numberRecords > 0 &&
      manageTimeEntry === "M" &&
      !rows?.some((row) => row.synced === true),
      icon: true,
     disabled:!rows || exportLoading || rows?.length < 1,
      iconButton: (
        <ReopenIcon color="#000000" width="24" height="24" />),
    },
    {
      label: "timesheet.btn.approve.label",
      handleClick: () => {
        handleOpenApproveConfirmationModal(true);
      },
      disabled:rows?.some((row) => row.automaticallyClosed === true) ||
      rows?.some((row) => row.synced === true) ||
      numberRecords === 0 ||
      status,
      condition:
      (!selected || selected?.length === 0) &&
      manageTimeEntry === "M" &&
      !timeEntriesClicked &&
      status === false ,
      icon: true,
      iconButton: <ApproveIconButton />
    },
    {
      label: "timesheet.btn.export",
      icon: true,
      condition: (!selected || selected?.length === 0) &&
      manageTimeEntry === "M" &&
      !timeEntriesClicked ,
      disabled: !rows || exportLoading || rows?.length < 1,
      iconButton: <ExportIconButton />,
      handleClick: () => { exportData() }
    },
    {
      label: "timesheet.btn.sendRequestApproval",
      icon: true,
      
      condition:!status,
      disabled:  TimeEntries.length === 0 ||
      !projectGuid ||
      rows?.some((row) => row.automaticallyClosed === true) ||
      rows?.some((row) => row.synced === true) ||
      status,
      iconButton: <RequestApprovalIcon />,
      handleClick: () => { setOpenApproverDialog(true); }
    },
    
    {
      label: "timesheet.btn.move.timeE",
      icon: true,
      condition: selected.length > 0 && !status,
      disabled: status || TimeEntries.length === 0,
      iconButton: (<MoveIcon color={"black"} width="24" height="24"/>),
      handleClick: () => { setOpenMoveTaskDialog(true); setFromTimsheet(true) }
    }
  ];

  const handleOpenModal = (row) => {
    setTaskID(row?.taskGuid);
    setProjectID(row?.projectGuids);
    setTaskName(row?.task);
    setProjectName(row?.project);
    setOpenModal(true);
  };

  const showCustomDiv = () => {
    return (
      <span style={{ fontSize: "13px", width: "10vw", display: "flex" }}>
        {t("timesheet.total.duration")} {totalDuration?.toFixed(2)}
      </span>
    );
  };


  const pagination = {
    rows,
    setRows,
    columns,
    filtersObject,
    defaultFilters,
    setDefaultFilters,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    selected,
    setSelected,
    search,
    refetch: refetchColumns,
    setSearch,
    setPage,
    setRowsPerPage,
    numberRecords,
    page,
    rowsPerPage,
    deleteText: "timesheet.list.delete.label",
    hideRefreshButton: true,
    hideAddButton: true,
    fetchTableData,
    loading:
      loading ||
      getColumnsLoading ||
      timeEntriesLoading ||
      projectLoading ,
    tableMnemonic: Mnemonic.Tables["TimesheetList"],
    searchText: "timesheet.list.search.label",
     readOnly: false || manageTimeEntry !== "M",
    handleDelete: handleDelete,
    deleteLoading,
    // hideEditColumns: true,
    removeRefresh: true,
    customButtons,
    keepFilters: true,
    linkCell,
    removeFilters:true,
    handleOpenModal,
    deletedRecords,
    showCustomDiv,
  };

  const customModalButtons = () => (
    <>
      <CustomButton onClick={handleSave} label={t("dialog.yes")} />
      <div>
        <CustomButton onClick={handleClose} label={t("dialog.cancel")} />
      </div>
    </>
  );
  const customModalButton2 = () => (
    <>
      <CustomButton onClick={handleWarningSave} label={fromTimesheet === true ? t("dialog.ok") : t("dialog.yes")} />
      <div>
        {fromTimesheet === false ?
          <CustomButton onClick={handleWarningClose} label={t("dialog.cancel")} />
          : null}
      </div>
    </>
  );

  const { mfunction: deleteRecords } = useMutationAuth(
    DELETE_TIME_ENTRY_LIST,
    "DeleteTimeEntries"
  );
  const timeEntryGuids = TimeEntries.map(entry => entry.timeEntryGuid);
  const handleDeleteRecords = () => {

    removeTimeEntry(
      {
        variables: {
          model: {
            timeEntriesIDs: timeEntryGuids,
            isRemoveAll: true,
            timesheetGuid: timesheetGuid || tID
          },
        },
      },
      (response) => {
        enqueueSnackbar(t("timesheet.clear.success"), {
          variant: "success",
        });
        setPage(0);
        fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
      },
      (error) => {
        enqueueSnackbar(t("timesheet.clear.error"), {
          variant: "success",
        });
      }
    );
  };

  const { mfunction: sendApprovalRequest } = useMutationAuth(
    SEND_TIMESHEET_APPROVAL_NOTIFICATION,
    "SendTimesheetApprovalNotification"
  );

  const checkIfUniqueProject = () => {
    if (projectValue!==null && projectValue.length === 1 && TimeEntries.length !== 0) {
      return true;
    }

    // If not, check consistency among timeEntries' projectGuids
    if (TimeEntries.length === 0) {
      enqueueSnackbar(t("timesheet.send.approval.no.timeentries"), {
        variant: "error",
        autoHideDuration: 5000
      });
      return false; // No entries to check, return false
    }
    return true;
  }


  const handleSendApprovalRequest = () => {
    sendApprovalRequest(
      {
        variables: {
          model: {
            timesheetGuid: tID
          },
        },
      },
      (response) => {
        if (
          response["SendTimesheetApprovalNotification"].errorCode !== null &&
          response["SendTimesheetApprovalNotification"].errorCode !== ""
        ) {
          enqueueSnackbar(t("timesheet.sendApproval.error"), {
            variant: "error",
            autoHideDuration: 5000
          });
          handleDeleteApprovalClose()
        } else {
          enqueueSnackbar(t("timesheet.sendApproval.success"), {
            variant: "success",
          });
          handleDeleteApprovalClose()
        }
      },
      (error) => {
        enqueueSnackbar(t("timesheet.sendApproval.unknownError"), {
          variant: "error",
        });
      }
    );
  };

  const [clearButtonClick, setClearButtonClicked] = useState(false)

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
  };

  const handleDeleteApprovalClose = () => {
    setOpenApproverDialog(false)
  }

  const handleDeleteSave = () => {
    setClearButtonClicked(true)
    handleDeleteRecords()
    setOpenDeleteDialog(false)
  };

  const handleApprovalRequestSave = () => {
    if (checkIfUniqueProject()) {
      handleSendApprovalRequest();
      setOpenApproverDialog(false);
    } else {
      setOpenApproverDialog(false);
    }
  };


  const customModalButtons3 = () => (
    <>
      <CustomButton onClick={handleDeleteSave} label={t("dialog.yes")} />
      <div>
        <CustomButton onClick={handleDeleteClose} label={t("dialog.cancel")} />
      </div>
    </>
  );

  const customModalButtons4 = () => (
    <>
      <CustomButton onClick={handleApprovalRequestSave} label={t("dialog.yes")} />
      <div>
        <CustomButton onClick={handleDeleteApprovalClose} label={t("dialog.cancel")} />
      </div>
    </>
  );

  const MAX_LENGTH_FOR_DISPLAY = 60;

  const getTimeEntriesButton = () => {
    setClickCount((prev) => {
      const newCount = prev + 1;

      if (editPendingMode && newCount === 1) {
        setShowWarning(true);
      } else if (newCount >= 2 && !timesheetGuid && !closeWarning) {
        setRe((val) => !val);
      }
      else if (newCount >= 2) {
        setShowWarning(true);
      } else {
        setRe((val) => !val);
        setEditPendingMode(true)
      }
      setEditPendingCount(newCount)
      return newCount;
    });
    setTimeEntriesClicked(true);
    setClearButtonClicked(false)

    setDeletedRecords([]);

  }

  const {
    data: projectPermissions,
    loading: loadingProjectPermissions,
  } = useQueryAuth(GET_ALL_PROJECT_PERMISSIONS, "GetProjectPermissions", {
    variables: {
      model: {
        enableFilters: false,
        projectIDs: projectValue,
        timesheetGuid: tID,
        userID: storeUserGuid,
      },
    },
    wait: timeEntriesLoading ||projectsWait ||projectLoading||excelTimeSheetLoading||timesheetLoading||getColumnsLoading ||columnsWait,
    skip: !tID ||  !tableColumns
  });

  const projectsPermisionsList = projectPermissions?.GetProjectPermissions?.projectPermissionsList?.resources

  useEffect(() => {
    if (projectsPermisionsList && timesheetApprover) {
      const employeeObj = projectsPermisionsList.find(
        p => p.employeeGuid === timesheetApprover
      );
      if (employeeObj) {
        setTimesheetApprover(employeeObj);
      }
    }
  }, [projectsPermisionsList, timesheetApprover]);


  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(false)
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleSaveButton = () => {
   
    updateRecords(
      {
        variables: {
          model: {
            timesheetGuid: timesheetGuid || tID,
            approverResourceGuid: timesheetApproverChanged ? saveResourceGuid.employeeGuid : timesheetApprover.employeeGuid,
            description: isChanged ? description : description,
          },
        },
      },
      (response) => {
        enqueueSnackbar(t("invoices.list.undo.success"), {
          variant: "success",
        });
        if (timesheetApproverChanged) {
          setTimesheetApprover(saveResourceGuid);
          setIsTimesheetApproverChanged(false);
        }
        if (isChanged) { setIsChanged(false) }
        sessionStorage.removeItem("unsavedChanges");
        setToSave(false)
      }
    );
  }
  const loadingStatus = loading ||
    projectLoading ||
    //taskLoading ||
     status

  return (
    <div>
      <ConfirmationModal
        contentText={
          reopenSheet
            ? t("dialog.user.sheet.approve.confirmation")
            : t("dialog.user.sheet.approve.confirmation")
        }
        title={t("dialog.warning")}
        icon={"warning"}
        openDialog={openDialog}
        handleClose={handleClose}
        customButtons={customModalButtons}
        t={t}
      />
      <ConfirmationModal
        contentText={fromTimesheet === true ? t("dialog.user.move.timesheet.confirmation") : t("dialog.user.delete.timesheet.confirmation")}
        title={t("dialog.warning")}
        icon={"warning"}
        openDialog={showWarning}
        handleClose={fromTimesheet === true ? handleWarningSave : handleWarningClose}
        customButtons={customModalButton2}
        t={t}
      />
      <ConfirmationModal
        contentText={t("dialog.user.clear.sheet.confirmation")}
        title={t("dialog.warning")}
        icon={"warning"}
        openDialog={openDeleteDialog}
        handleClose={handleDeleteClose}
        customButtons={customModalButtons3}
        t={t}
      />
      <ConfirmationModal
        contentText={t("dialog.user.sendApprover.sheet.confirmation")}
        title={t("dialog.warning")}
        icon={"warning"}
        openDialog={openApprovalDialog}
        handleClose={handleDeleteApprovalClose}
        customButtons={customModalButtons4}
        t={t}
      />
      <TaskTabsModal
        showModal={openModal}
        setShowModal={(v) => setOpenModal(v)}
        loading={loading}
        projectID={projectID}
        projectName={projectName}
        taskID={taskID}
        handleChangeProject={(v) => setProjectID(v)}
        handleChangeTask={(v) => setTaskID(v)}
        taskName={taskName}
        refetch={refetchTimesheet}
        fromProject={true}
        editMode={true}
        setType={(v) => type.current = v}
        type={type.current}
        open={JSON.parse(sessionStorage.getItem("unsavedChanges"))}
        modifyFormFlag={() =>
          sessionStorage.setItem("unsavedChanges", JSON.stringify(false))
        }
      />
      <MoveTimeEntryModal
        selectedTimeEntry={selected}
        setSelectedTimeEntry={setSelected}
        // parentTask={parentTask}
        openDialog={openMoveTaskDialog}
        handleClose={() => setOpenMoveTaskDialog(false)}
        callButton={() => getTimeEntriesButton()}
        changeNewlyOpen={openMoveTaskDialog}
        fromTimesheet={fromTimesheet}
        setFromTimesheet={setFromTimsheet}
        // handleFetchTree={handleFetchTree}
        // handleSelectFirstTask={handleSelectFirstTask}
        t={t}
      />

      <TimeEntryDrawer
        PaperComponent={PaperComponent}
        openTimeEntryModal={clicked}
        setOpenTimeEntryModal={(v) => setClicked(setClicked)}
        timeEntryGuid={timeEntry?.timeEntryGuid}
        description={timeEntry?.description}
        synced={manageTimeEntry !== "M" ? true : timeEntry?.synced}
        refetchData={refetchTimesheet}
        editMode={editMode}
        handleEditMode={(v) => setEditMode(v)}
       fromTimesheet={true}
        group={true}
        t={t}
      />
      {(!tID || (tID && editPendingMode)) && (
        <Box sx={{
          backgroundColor: "#FFFFFF", // White background
          borderRadius: "5px", // Rounded corners
          boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)", // Optional: subtle shadow for better visibility
          padding: "16x", // Adds padding inside the box
          marginBottom:"20px",
          marginTop:"20px"
        }}>
        <Grid container spacing={3} sx={{
    width: "100%",
    paddingLeft: "5px",
    paddingTop: "5px"

        }}>
          {/* Left Side: Description & Project Permissions */}
           <form  onSubmit={handleSaveButton} style={{ width: "100%", paddingBottom:"15px",paddingTop:"15px" }}> 
            <Grid item xs container spacing={3} alignItems="center" justifyContent="space-between">
        
            <Grid item xs={6}>
              <Tooltip title={description.length > MAX_LENGTH_FOR_DISPLAY ? description : ""} enterTouchDelay={0}>
                <TextField
                  size="small"
                  fullWidth
                  label="Description"
                  variant="standard"
                  value={description}
                  disabled={status === null || status === true}
                  onChange={handleChange}
                  onSubmit={handleSaveButton}
                  onBlur={handleSaveButton}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevents form from reloading
                      handleSaveButton(); // Calls the function
                    }
                  }}
                 />
              </Tooltip>
            </Grid>
           
            <Grid item xs={4}>
              <AutoComplete
                loading={loadingProjectPermissions}
                options={projectsPermisionsList || []}
                getOptionLabel={(option) =>
                  option && option.firstName && option.lastName
                    ? `${option.firstName} ${option.lastName}`
                    : ""
                }
                renderOption={(props, option) => (
                  <li {...props} key={option && option.employeeGuid}>
                    {option && option.firstName && option.lastName
                      ? `${option.firstName} ${option.lastName}`
                      : "No available option"}
                  </li>
                )}
                size="small"
                identifier="employeeGuid"
                value={timesheetApprover}
                onChange={(event, value) => {
                  if (value) {
                    handlechangeTimesheetApprover(value);
                 
                  } else {
                    setTimesheetApprover(null);
                  }
                }}
                sx={{ paddingTop: "2px" }}
                label={t("reports.label.timesheetApprover")}
                disabled={status === null || status === true}
              />
            </Grid> 
         
          
          {/* Right Side: status cell */}
          <Grid item xs={2}>
          <Grid container spacing={1}  sx={{paddingTop:"15px"}} alignItems="center" justifyContent="flex-end">           
              {status === null ? null : (
                <Grid item>
                  <StatusCell
                    label={status === true ? "Approved" : "Pending"}
                    color={status === true ? "success" : "pending"}
                  />
                </Grid>
              )}
      
      </Grid> 
      </Grid> 
          </Grid></form>
        </Grid>
      </Box>
      
      )}
      <Box
        sx={{
          marginTop: {
            xs: "10px !important",
            sm: "10px !important",
            md: "10px !important",
            lg: "10px !important",
            xl: "10px !important",
          },
          backgroundColor: "white",
          border: '1px solid #f5f5f5',
          paddingTop: "10px",
          paddingLeft: "10px",
          padddingRight: "10px",
        }}
      >

        {(!tID || (tID && editPendingMode)) && (
          <Grid container spacing={1} alignItems="center">
       <Grid
              item
              xs={12}
              sm={4}
              md={3}
            >    <Tooltip title={(tID && editPendingMode && !clearButtonClick && totalDuration !== 0)?t("timesheet.disabledField.msg"):null}> 
            <span>   <AutoComplete
                multiple
                disableCloseOnSelect
                loading={projectLoading}
                options={projectsList}
                getOptionLabel={(option) => (option ? option.title : "")}
                renderOption={(props, option) => (
                  <li {...props} key={uuidv4()}>
                    {option.title}
                  </li>
                )}
                identifier={"projectGuid"}
                size="small"
                value={projectsList.filter(p => projectValue?.includes(p.projectGuid))}
                onChange={(event, value) => {
                  if (value) {
                    setProjectInfo(value.map(item => item))
                    setProjectValue(value.map(item => item.projectGuid));
                    fetchedFromLocation.current = false;
                    setRows([]);
                  } else {
                    setProjectValue(null)
                    setProjectGuid(null)
                  }
                }}

                disabled={(tID && editPendingMode && !clearButtonClick && totalDuration !== 0)}
                sx={{
                  "& .MuiInputBase-input": { fontSize: "13px !important" },
                }}
                label={t("reports.label.projects")}
                roundedTextField
              /></span></Tooltip>
            </Grid>

            <Grid item xs={12} sm={4} md={1.5}>
            <Tooltip title={(tID && editPendingMode && !clearButtonClick && totalDuration !== 0)?t("timesheet.disabledField.msg"):null}> 
            <span> 
              <RoundedDatePicker
                className="date_picker_styles"
                label={t("projectDashboard.label.DateFrom")}
                value={dateFrom}
                disabled={(tID && status === null) || (tID && status === true)}
                onChange={(newValue) => {
                  if (newValue) {
                    setDateFrom(newValue);
                  }

                  setDateVal(
                    data_filter.find((x) => x.mnemonic === "custom")
                  );
                }}
                onClose={() => setOpen(true)}
              /></span></Tooltip>
            </Grid>
            <Grid item xs={12} sm={4} md={1.5} >
            <Tooltip title={(tID && editPendingMode && !clearButtonClick && totalDuration !== 0)?t("timesheet.disabledField.msg"):null}> 
            <span> 
              <RoundedDatePicker
                className="date_picker_styles"
                label={t("projectDashboard.label.DateTo")}
                value={dateTo}
                // disableFuture
                shouldDisableDate={disableDates}
                autoFocus={open}
                open={open}
                onClose={() => setOpen(false)}
                onClick={() => setOpen(!open)}
                onOpen={() => setOpen(!open)}
                disabled={(tID && status === null) || (tID && status === true)}
                onChange={(newValue) => {
                  fetchedFromLocation.current = false;
                  handleValidateDates(
                    timer,
                    setTimer,
                    dateFrom,
                    newValue,
                    setDateTo,
                    enqueueSnackbar,
                    t
                  );
                  setDateVal(
                    data_filter.find((x) => x.mnemonic === "custom")
                  );
                }}
              // renderInput={(params) => (
              //   <RoundedTextField removeMinWidth {...params} />
              // )}
              />
              </span></Tooltip>
            </Grid>
            <Tooltip title={t("tooltip.PreviousPeriod")}>
              <Grid item >
                <PreviousIcon
                  disabled={(tID && status === null) || (tID && status === true)}
                  color={
                    dateVal.mnemonic === "custom" ? "#73717380" : "#737173"
                  }
                  onClick={() => {
                    if (dateVal.mnemonic !== "custom" && status === false)
                      handleDateBackward(
                        dateFrom,
                        dateTo,
                        dateVal,
                        setDateFrom,
                        setDateTo
                      );
                  }}
                />
              </Grid>
            </Tooltip>
            <Grid item xs={12} sm={4} md={1.5} >
            <Tooltip title={(tID && editPendingMode && !clearButtonClick && totalDuration !== 0)?t("timesheet.disabledField.msg"):null}> 
            <span> 
              <Autocomplete
                options={data_filter}
                getOptionLabel={(option) => (option ? t(option.name) : "")}
                renderOption={(props, option) => (
                  <li {...props} key={uuidv4()}>
                    {t(option.name)}
                  </li>
                )}
                isOptionEqualToValue={(option, value) =>
                  value ==="" || option.mnemonic === value.mnemonic
                }
                size="small"
                disableClearable
                value={dateVal}
                disabled={(tID && status === null) || (tID && status === true)}
                onChange={(event, value) => {
                  fetchedFromLocation.current = false;
                  setDateVal(value);
                  handleTimeBetween(value.mnemonic, setDateFrom, setDateTo);
                }}
                fullWidth
                PaperComponent={(props) => <AutoCompletePaper {...props} />}
                renderInput={(params) => (
                  <RoundedTextField
                    label={t("dateFilter.label")}
                    size="small"
                    removeMinWidth
                    {...params}
                  />
                )}
                sx={{ ".MuiInputBase-input": { fontSize: "14px !important" } }}
              />   </span></Tooltip>
            </Grid>
            <Tooltip title={t("tooltip.NextPeriod")}>
              <Grid item >
                <NextIcon
                  color={
                    dateVal.mnemonic === "custom" ? "#73717380" : "#737173"
                  }
                  onClick={() => {
                    if (dateVal.mnemonic !== "custom" && status === false)
                      handleDateForward(
                        dateFrom,
                        dateTo,
                        dateVal,
                        setDateFrom,
                        setDateTo
                      );
                  }}
                />
              </Grid>
            </Tooltip>
         
          </Grid>
        )}
        {getColumnsLoading ? (
          <ContainerCard
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <CircularProgress />
          </ContainerCard>
        ) : (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <DataTable
              {...pagination}
              identifier="timeEntryGuid"
              fromTimesheets
              rows={rows}
              
              heightClassName="table-monthly-sheet-height"
              isFixed
              hasCheckbox={true}
              // {
              //   (rows?.filter((row) => row.synced === true).length !== rows?.length) && (isAdmin || timesheetApprover === storeUserGuid)
              // }
              // checkForCheckbox={(row) => row.synced !== true}
            />
          </Grid>
        )}
      </Box>
    </div>
  );
};

export default NewTimesheet;